module.exports = __webpack_public_path__ + "static/media/01.21b680c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/india/01.jpg
// module id = 421
// module chunks = 0